module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-12.b424d988.png";